import { useLocation } from 'react-router-dom'

import { useUserTutorials } from 'src/app/popups/api/use-user-tutorials'
import { CompleteProfilePopup } from 'src/app/popups/components/complete-profile-popup'
import { popupRoutes } from 'src/app/popups/config/popup-routes'
import { usePopupStore } from 'src/shared/store/popup-store'

export const DynamicPopups = () => {
  const location = useLocation()
  const { data: tutorials } = useUserTutorials()
  const { showCompleteProfile } = usePopupStore()

  if (!tutorials) return null

  // Find all popups that should be shown on the current path
  const activePopups = popupRoutes.filter((popup) => {
    // Check if current path matches any of the popup's paths
    const pathMatch = popup.paths.includes('*') || popup.paths.some((path) => location.pathname === path)

    // Check if the tutorial hasn't been completed yet (if it's a tutorial popup)
    const tutorialIncomplete = popup.tutorialKey ? !tutorials[popup.tutorialKey] : true

    // Check additional show conditions
    const showConditionMet = popup.component === CompleteProfilePopup ? showCompleteProfile : true

    return pathMatch && tutorialIncomplete && showConditionMet
  })

  return (
    <>
      {activePopups.map((popup, index) => {
        const PopupComponent = popup.component
        return <PopupComponent key={`${popup.tutorialKey || 'popup'}-${index}`} />
      })}
    </>
  )
}
